import { QUERY_BOX_TYPES, REFERENCED } from 'utils/constants'
import { curry, propEq, prop, propOr, length } from 'ramda'

// Takes a map of queries (by uri) and breadth-first  recurses over them
// to maps the uris into a 2-D array: columns of uris by level in the hierarchy.
// e.g. if q1 is the top uri, has children of q12 and q13, and q12 has children q121 and q122, q13 has child 131,
// then we'd end up with [  [q1],  [q12, q13],  [q121, q122, q131]   ]
const makeNode = (query, parentBox) => {
  const { queryType, uri, subType, functionUris, description } = query
  return {
    description,
    uri,
    queryType,
    parentBox,
    functionUris,
    ...(subType && { subType }),
  }
}

export const getFunctionGraph = curry(
  (isOutputTypeNative, outputQueryUri, conditions, queryMap) => {
    const query = prop(outputQueryUri, queryMap)
    const firstColumn = query ? [makeNode(query, null)] : null

    const columns = [firstColumn]
    const foundComplexQueries = new Set(outputQueryUri ? [outputQueryUri] : [])

    // refactor this out of this function
    const addChildBoxesToNextColumn = (query, nextColumn) => {
      const childBoxes = []
      const queryConditionUris = propOr([], 'conditions', query)

      queryConditionUris.forEach((uri) => {
        const condition = prop(uri, conditions)
        if (isQueryTypeReferenced(condition)) {
          const refQueryUri = prop('refQueryUri', condition)
          const logicNode = prop(refQueryUri, queryMap)
          const logicNodeUri = prop('uri', logicNode)

          const canBeAddedToGraph =
            logicNode && !foundComplexQueries.has(logicNodeUri)

          if (canBeAddedToGraph) {
            childBoxes.push(logicNodeUri)
            foundComplexQueries.add(logicNodeUri)
            const nextNodeUri = prop('uri', query)

            const newNode = makeNode(logicNode, nextNodeUri)
            nextColumn.push(newNode)
          }
        }
      })
      return childBoxes
    }

    ;(function recurseBuiltColumns(parentsColumn) {
      const newColumn = []

      if (parentsColumn) {
        parentsColumn.forEach((node) => {
          const nodeUri = prop('uri', node)
          const query = prop(nodeUri, queryMap)

          if (isQueryBoxType(query)) {
            node.childBoxes = addChildBoxesToNextColumn(query, newColumn)
            node.conditions = prop('conditions', query)
          }
        })
      }

      if (length(newColumn)) {
        columns.push(newColumn)

        recurseBuiltColumns(newColumn)
      }
    })(firstColumn)

    return { columns: columns.filter(Boolean) }
  }
)

// //////////////////////////////////////
// HELPERS
const isQueryBoxType = (query) => QUERY_BOX_TYPES.has(prop('queryType', query))

const isQueryTypeReferenced = propEq('queryType', REFERENCED)
